import {Component} from 'react';
import h from 'react-hyperscript';
import './GoogLogoutButton.scss';

class GoogLogoutButton extends Component {
  render() {
    return (
      h('a', {
        id: this.props.id,
        className: this.props.className,
        onClick: (e) => {
          if (this.props.handleMenuClose) {
            this.props.handleMenuClose();
          }
          this.props.onClick();
        },
      }, 'Logout')
    );
  }
}

export default GoogLogoutButton;
